import React from "react";
import { Link } from "react-router-dom";
import hshape from "../assets/img/hshape.svg";
const LearnSection = () => {
    return (
        <section className="learn-sec">
            <div className="container-xl">
            <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="main-h">
                            <h2 className="m-heading">Learn in Confidence with Our<br /> 
                            Accredited E-Learning Courses</h2>
                            <img src={hshape} className='img-fluid ' alt="logo" />
                        </div>
                        <p>Elevate your skills and advance your career with our CPD-accredited and Skills for Care-endorsed e-learning courses. Whether you're pursuing professional development or expanding your knowledge, our platform ensures quality learning experiences tailored to your needs.</p>
                    </div>
                </div>
              
            </div>
        </section>
    );
};

export default LearnSection;